<template>
  <div class="sort-option h-v-centerer" :class="elClasses">
    <div class="sort-option__text small-text">
      {{ label }}
    </div>

    <div v-if="sortable" class="sort-option__icons">
      <Icon>{{ arrowDownLine }}</Icon>
      <Icon>{{ arrowDownLine }}</Icon>
    </div>
  </div>
</template>

<script>
/**
 * Option displayed as part of the header of a list.
 * Can be used to display the sorting option of the list.
 *
 * @vue-prop {String} label - Name of the option
 * @vue-prop {Boolean} [sortable] - If true, features two opposed arrows indicating the sorting option
 * @vue-prop {Boolean} [isCurrent] - This is the crrently selected opton (adds bold text)
 * @vue-prop {Boolean} [isDesc] - If is current, also highlight the descending arrow. Else ascending
 */
import Icon from '@/components/icon.vue';
import { arrowDownLine } from '@/assets/icons';

export default {

  name: 'SortOption',

  components: {
    Icon,
  },

  props: {
    label: {
      type: String,
      default: '',
    },
    sortable: Boolean,
    isCurrent: Boolean,
    isDesc: Boolean,
  },

  data() {
    return {
      arrowDownLine,
    };
  },

  computed: {
    /** Object: Classes of this.$el */
    elClasses() {
      return {
        'sort-option--sortable': this.sortable,
        'sort-option--current': this.isCurrent,
        'sort-option--desc': this.isDesc,
      };
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.sort-option {
  padding: 0 0.15em;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;

  & &__text {
    font-weight: 500;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  &__icons {
    text-align: center;
    margin-left: 0.5em;

    .icon {
      width: 0.5em;
      height: 0.54em;
      display: block;

      &:first-child {
        transform: rotate(180deg);
      }

      &:last-child {
        margin-top: -1px;
      }
    }
  }

  &--sortable {
    cursor: pointer;
    padding: 0 0.25em;
  }

  &--current {

    .sort-option__text {
      font-weight: 600;
    }

    .sort-option__icons {
      .icon {
        width: 0.6em;
        height: 0.6em;
      }
    }

    &.sort-option--desc {
      .sort-option__icons .icon:first-child {
        display: none;
      }
    }

    &:not(.sort-option--desc) {
      .sort-option__icons .icon:last-child {
        display: none;
      }
    }
  }
}
</style>
